import React, { useCallback, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CustomModal, BackgroundIcon, Loader, Icon } from '@nile/components';
import styled from 'styled-components';
import { AccountClient, MockTicketClient } from '@nile/graphql';
import { Page, Button } from '@superops/ui-design-system';
import { Times } from '@styled-icons/fa-solid';
import { SVGIcon } from '@superops/super-icons';
import dompurify from 'dompurify';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const MessageWrapper = styled.div`
  min-width: 1200px;
  max-width: 1200px;
  height: 90vh;

  .justify-between {
    justify-content: space-between;
  }
`;

const Wrapper = styled.div`
  padding: ${(props) => (props.fullHeight ? '20px' : '0 16px 16px')};
`;

const DisplayOriginalMessage = (props) => {
  const [sheetActive, setSheetActive] = useState(false);
  const { query, input, responseKey } = props;
  const [loading, setLoading] = useState(false);
  const [originalContent, setOriginalContent] = useState(null);

  const toggleSheetActive = useCallback(async () => {
    setSheetActive((sheetActive) => !sheetActive);
    // const input = {
    //   workItem: {
    //     workId: workItemId,
    //     module: module
    //   },
    //   conversation: {
    //     conversationId: message?.parentConversationId ?? message?.conversationId
    //   }
    // };

    setLoading(true);
    const response = await AccountClient.query({
      query: query,
      variables: {
        input: input
      },
      fetchPolicy: 'network-only'
    });
    setLoading(false);
    setOriginalContent(response?.data?.[responseKey]);
  });

  const closeSheet = useCallback(() => {
    setSheetActive((sheetActive) => !sheetActive);
  });

  const stopEvents = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div onClick={stopEvents}>
      <Wrapper onClick={toggleSheetActive} className="flex cp p16">
        <span className="mr8">
          <SVGIcon name="MailSettings" />
        </span>
        <FormattedMessage id="client.details.chat.originalMessage" />
      </Wrapper>

      <CustomModal open={sheetActive} onClose={closeSheet}>
        <MessageWrapper>
          <Page
            variant="primary"
            contentHeight="120px"
            title={
              <FormattedMessage id="client.details.chat.originalMessage.heading" />
            }
            primaryAction={
              <Button
                onClick={() => {
                  closeSheet();
                }}
                plain
                icon={<SVGIcon name="Close" />}
              />
            }
          >
            {loading ? (
              <Loader />
            ) : (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: dompurifier(originalContent)
                  }}
                />
              </>
            )}
          </Page>
        </MessageWrapper>
      </CustomModal>
    </div>
  );
};

export default injectIntl(DisplayOriginalMessage);
